var map = {
	"./angular-integrations/beta-tag.angular.ts": "KKtj",
	"./angular-integrations/call-overlay/call-overlay.angular.tsx": "kZ+m",
	"./angular-integrations/closed-captions.angular.ts": "BGmn",
	"./angular-integrations/closed-captions/closed-captions.angular.tsx": "sfia",
	"./angular-integrations/participant-publisher-error.angular.ts": "glGS",
	"./angular-integrations/self-publisher-error.angular.ts": "40em",
	"./components/CallMenuButton/call-menu-button.angular.ts": "6e3O",
	"./components/CallQualitySurvey/provider-survey.angular.ts": "mwqJ",
	"./components/EndCallConfirmationPopup/end-call-confirmation-popup.angular.ts": "WRxV",
	"./components/PictureInPictureFrame/picture-in-picture-frame.angular.ts": "YAhp",
	"./components/VideoMutedOverlay/video-muted-overlay.angular.ts": "t7ND",
	"./components/pin-icon/pin-icon.angular.ts": "vl4g"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g65e";